import dark from "./dark";

export default {
  dark,
  light: dark
};
